module.exports = __webpack_public_path__ + "static/media/parent.a11ae6a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/parent.svg
// module id = 2026
// module chunks = 0